import React from "react";
import PropTypes from "prop-types";

/**
 * NeoEmptyState
 * Componente de estado vazio, tela de boas-vindas ou instrução de alta fidelidade do NeoApp.
 * Totalmente integrado ao padrão visual Taça Outono, eliminando estilos inline.
 */
const NeoEmptyState = ({ 
    icon = "mdi-filter-outline", 
    title, 
    description, 
    highlightText,
    action 
}) => {
    return (
        <div className="neo-empty-state">
            <div className="neo-empty-state-icon-bg">
                <i className={`mdi ${icon} neo-empty-state-icon`} />
            </div>
            <h6 className="neo-empty-state-title">{title}</h6>
            <p className="neo-empty-state-description">
                {description}
                {highlightText && (
                    <strong className="neo-empty-state-highlight">
                        {" "}{highlightText}
                    </strong>
                )}
            </p>
            {action && <div className="neo-empty-state-action">{action}</div>}
        </div>
    );
};

NeoEmptyState.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    highlightText: PropTypes.string,
    action: PropTypes.node
};

export default NeoEmptyState;
